import SubHeader from "../../components/header/SubHeader";
import React, {useEffect, useState} from "react";
import SearchInput from "../../components/common/form/SearchInput";
import {useDispatch, useSelector} from "react-redux";
import {fetchProducts, manageProduct, resetProductManageStatus} from "../../store/product-slice";
import {getEditableTableColumns, getEditableTableData} from "../../models/productModel";
import TableEdit from "../../components/common/table/TableEdit";
import {useNavigate} from "react-router-dom";
import AlertMessage from "../../components/ui/AlertMessage";
import Stack from "../../components/ui/Stack";

const ProductManage = () => {
    const dispatch = useDispatch();
    const navigator = useNavigate();
    const [searchText, setSearchText] = useState("");
    const [alertInfo, setAlertInfo] = useState(null);
    const {
        items,
        fetchStatus,
        productManageStatus,
        pagination,
        error
    } = useSelector(state => state.product);

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchProducts({
            ...userRole,
        }));
    }, [dispatch, userRole]);

    useEffect(() => {
        if (productManageStatus === "success") {
            setAlertInfo({
                message: "Products have been updated successfully.",
                variant: "success",
            });
            dispatch(resetProductManageStatus());

            //Relaod the page after the changes
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }
    }, [dispatch, productManageStatus, navigator]);

    const submitHandler = (data) => {
        if (!data || data.length === 0) {
            setAlertInfo({
                message: "No changes in price or stock/Stock Threshold.",
                variant: "warning",
            });
            return;
        }

        const updatedData = {
            id: userRole.scopeId,
            products: [...data],
        }
        dispatch(manageProduct({...userRole, data: updatedData}));
    }

    const tableColumns = getEditableTableColumns();
    const tableData = getEditableTableData({items});
    return (
        <>
            <SubHeader title="Manage Products"/>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {(fetchStatus === "failed" || productManageStatus === "failed") && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" &&
                <>
                    <Stack className="justify-content-between align-items-center">
                        <SearchInput value={searchText}
                                     onChange={(e) => setSearchText(e.target.value)}
                                     placeholder="Search by product name & tag..."
                                     columns={{md: 4, lg: 3}}
                                     className="mb-4"/>
                        <p className="mb-0 fs-md"><span className="text-secondary">Total Items:</span><span
                            className="text-primary ms-1">{pagination?.results}</span></p>
                    </Stack>
                    <div className="container p-0 ms-0">
                        <TableEdit className="mobile-responsive mt-4" columns={tableColumns} data={tableData}
                                   onSubmitChanges={submitHandler}
                                   idField="productId"
                                   searchQuery={searchText} searchFields={["name"]}/>
                    </div>
                </>
            }
            {alertInfo && (
                <AlertMessage
                    message={alertInfo.message}
                    variant={alertInfo.variant}
                    duration={2000}
                    onClose={() => setAlertInfo(null)}
                />
            )}
        </>
    )
}

export default ProductManage;